export default {
  setSummary(state, data) {
    state.summary = data
  },

  setSettings(state, settings) {
    state.settings = { ...state.settings, ...settings }
  },

  setUsers(state, users) {
    state.users = users
  },

  updateUser(state, payload) {
    state.users = [...state.users].map(({ user, timesheets }) => {
      if (payload.user.id === user.id) {
        return {
          user,
          timesheets: timesheets.map(timesheet => {
            const item = payload.timesheets.find(({ id }) => id === timesheet.id)

            if (item) {
              return { ...timesheet, ...item }
            }

            return { ...timesheet }
          }),
        }
      }

      return { user, timesheets }
    })
  },
}
